export type MonitoringApiHandle =
  | `/hi/type/${string}`
  | `/hi/type/by_name/${string}`
  | `/hi/type/${string}/name`
  | `/hi/types`
  | `/hi/types/allowed`
  | `/hi/types/list`
  | `/hi/type`
  | `/hi/statuses`
  | `/template/${string}`
  | `/templates`
  | `/template`
  | `/tql_metric/map`
  | `/template/${string}/tql_metric/${string}`
  | `/tql_metrics/template/fields`
  | `/tql_metrics/template`
  | `/tql_metric/${string}/enable_all`
  | `/exporters`
  | `/exporter/${string}`
  | `/exporters/config/storage`
  | `/exporter`
  | `/exporter/no_control`
  | `/exporter/redis`
  | `/exporter/container`
  | `/exporter/${string}/no_control`
  | `/exporter/${string}/redis`
  | `/exporter/${string}/container`
  | `/exporter/${string}/apply`
  | `/exporter/metric/stub`
  | `/settings`
  | `/settings/${string}`
  | `/schedules`
  | `/schedules/${string}`
  | `/reset`
  | `/prometheus/raw_query`
  | `/vmagent/config`
  | `/vmalert/rules`
  | `/his/rules`
  | `/his/rule/${string}`
  | `/his/rule`
  | `/his/rule/name/${string}`
  | `/his/rule/${string}/types`
  | `/his/rules/accesses`
  | `/his/rules_brief`
  | `/his/rules/actions`
  | `/api/v2/alerts`
  | `/api/v2/alerts_yaml`
  | `/api/v2/alerts/${string}`
  | `/alerts/tests/hi`
  | `/alerts/tests/ci`
  | `/alerts/${string}/close`
  | `/alerts/close`
  | `/hi/propagation/links`
  | `/hi_history/high_level`
  | `/hi_history/high_level_ci`
  | `/hi_history/level_down`
  | `/hi_history/level_up`
  | `/hi_history/tree_down`
  | `/hi_history/tree_up`
  | `/hi_history/sot_alerts`
  | `/hi_history/hi_chronology`
  | `/hi_history/sot_depends`
  | `/hi_history/sot`
  | `/hi_history/alerts`
  | `/hi_history/hi_types`
  | `/hi_history/hi_values`
  | `/hi_history/annotations`
  | `/hi_history/ci_his`
  | `/hi_history/ci_statuses`
  | `/hi_history/cis`
  | `/hi_history/hi_group_history`
  | `/hi_history/ci_summary`
  | `/hi/tql_links/template/${string}`
  | `/hi/tql_link/map`
  | `/hi/tql_link/${string}/enable_all_v2`
  | `/hi/tql_links/depends/template/${string}/src_node/${string}/dst_node/${string}`
  | `/hi/tql_links/ci_type/${string}`
  | `/hi/tql_links/hi_types`
  | `/hi/tql_links/hi_type_name/${string}`
  | `/hi/tql_links/info`
  | `/hi/tql_hi_link/alert_hint/${string}`
  | `/hi/tql_hi_link/alert_hint`
  | `/hi/tql_hi_link/event_hint/${string}`
  | `/hi/tql_hi_link/event_hint`
  | `/hi/tql_hi_link/static/${string}`
  | `/hi/tql_hi_link/static`
  | `/hi/tql_hi_link/raw/${string}`
  | `/hi/tql_hi_link/raw`
  | `/hi/tql_hi_link/calculate/${string}`
  | `/hi/tql_hi_link/calculate`
  | `/hi/active_his/tree`
  | `/hi/active_his`
  | `/hi/active_his/high_level`
  | `/hi/active_his/high_level_ci`
  | `/hi/active_hi/level_down`
  | `/hi/active_hi/level_up`
  | `/hi/active_his/group_by`
  | `/import/templates/execute`
  | `/import/templates/validate`
  | `/import/templates/analyze`
  | `/import/exporter/analyze`
  | `/import/exporter/validate`
  | `/import/exporter/execute`
  | `/import/hi_type/analyze`
  | `/import/hi_type/validate`
  | `/import/hi_type/execute`
  | `/import/job/analyze`
  | `/import/job/validate`
  | `/import/job/execute`
  | `/import/vmagent/analyze`
  | `/import/vmagent/validate`
  | `/import/vmagent/execute`
  | `/import/vmalert/analyze`
  | `/import/vmalert/validate`
  | `/import/vmalert/execute`
  | `/jobs`
  | `/jobs/config`
  | `/jobs/grouped_vmagents`
  | `/job/${string}`
  | `/job`
  | `/job/export/json`
  | `/hi/type/export/json`
  | `/exporter/export/json`
  | `/templates/export/json`
  | `/template/${string}/copy`
  | `/vmagent/${string}`
  | `/vmagents`
  | `/vmagent/${string}/${string}/targets`
  | `/vmagent/${string}/config`
  | `/vmagent/export/json`
  | `/vmagent`
  | `/vmagent/proxy/query/preview`
  | `/vmagent/proxy/query`
  | `/vmagent/proxy/series/preview`
  | `/vmagent/proxy/series`
  | `/vmagent/proxy/query_range/preview`
  | `/vmagent/proxy/query_range`
  | `/vmalert/${string}`
  | `/vmalerts`
  | `/vmalert/${string}/config`
  | `/vmalert/export/json`
  | `/vmalert`
  | `/tql_metrics/for_template/${string}`
  | `/template/${string}/tql_metric`
  | `/opensearch/proxy/${string}/search`
  | `/opensearch/proxy/${string}/search/preview`
  | `/opensearch/cursor/close`
  | `/opensearch/proxy/${string}/field_caps`
  | `/s3`
  | `/s3/${string}`
  | `/s3/${string}/check`
  | `/hi/evidence`
  | `/media/${string}`
  | `/`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface MonitoringInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = MonitoringApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<T = any, R = AxiosResponse<T>, P extends string = MonitoringApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = MonitoringApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = MonitoringApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const monitoringInstance = axios.create({
  baseURL: '/api/monitoring/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as MonitoringInstance;

i18n.on('languageChanged', (lng) => {
  monitoringInstance.defaults.headers.common['Accept-Language'] = lng;
});
